<template>
  <article class="VB_Brochure_Text">
    <section
      v-for="(step, index) in textData"
      class="VB_Brochure_Text_Section"
      :key="index"
    >
      <h3 class="VB_Brochure_Text_Section_Header">
        {{ step.h || $t("overview") }}
      </h3>

      <p class="VB_Brochure_Text_Section_Body">
        {{ step.t }}
      </p>
    </section>
  </article>
</template>

<script>
export default {
  name: "ViewmedicaBrochureText",

  props: {
    textData: {
      required: true,
      type: Array
    }
  }
};
</script>

<style lang="scss">
.VB_Brochure_Text {
  position: absolute;
  font-family: helvetica, arial, san-serif;
  line-height: 1.3;
  font-size: 9pt;
  top: 100pt;
  right: 24pt;
  width: 208pt;
  height: 680pt;

  @media print {
    height: auto !important;
  }

  &_Section {
    padding-bottom: 11pt;

    &_Header {
      font-weight: 700;
      font-size: 9pt;
    }

    &_Body {
      font-weight: 400;
      font-size: 9pt;
    }
  }
}
</style>
